// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CircleCheck = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M48 87.5C26.185 87.5 8.5 69.815 8.5 48S26.185 8.5 48 8.5 87.5 26.185 87.5 48 69.815 87.5 48 87.5ZM37.693 60.62 26.817 49.744l-3.505 3.625L37.694 67.75 68.63 36.813l-3.625-3.626L37.693 60.62Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default CircleCheck;
